import React from 'react';

/** StatBlock — big serif number + small label. Wrap several in `.stats`. */
export default function StatBlock({ value, label, className = '' }) {
  return (
    <div className={`stat${className ? ` ${className}` : ''}`}>
      <div className="stat__value">{value}</div>
      <div className="stat__label">{label}</div>
    </div>
  );
}
